//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React from 'react';
import { useTranslation } from 'react-i18next';
import { commonStyles } from '../../styles/commonStyles';
import { useUserAuth } from '../../UserAuth';
import { useTheme } from '../../ThemeContext';

interface HeaderProps {
  showFirstBar?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showFirstBar = true }) => {
  const { t } = useTranslation();
  const { user } = useUserAuth();
  const { darkMode } = useTheme();

  return (
    <>
      {showFirstBar && (
        <div
          id="first-bar"
          data-testid="first-bar"
          style={commonStyles.firstBar(darkMode)}
        >
          <div
            id="first-bar-inner"
            data-testid="first-bar-inner"
            style={commonStyles.firstBarInner}
          >
            <div
              id="welcome-section"
              data-testid="welcome-section"
              style={commonStyles.welcomeSection}
            >
              <div
                id="welcome-message"
                data-testid="welcome-message"
                style={commonStyles.firstBarText}
              >
                {t('welcomeMessage')}
                <span
                  id="username"
                  style={{
                    ...commonStyles.firstBarText,
                    marginLeft: '0.5vh',
                  }}
                >
                  {user.profile.name ? user.profile.name : 'Guest'}!
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
